import axios from 'axios';
import { ReactNode } from 'react';
import useSWR, { mutate } from 'swr';
// import { AdminInfoResponse } from '../pages/Dashboard/DashboarEntreprise/Ttype';

// API_BASE_URL: Définit l'URL de base de l'API à partir des variables d'environnement.
const API_BASE_URL = import.meta.env.VITE_API;


// fetcher: Fonction fetcher pour useSWR, utilisant Axios pour récupérer les données.
const fetcher = (url: string) => axios.get(url).then((res) => res.data);

// Interface Application: Définit la structure des données d'une application.
export interface Application {
  userCount: number;
  isSuccess: any;
  data: any;
  role: 'string';
  redirectUri: any;
  redirectUris: string;
  redirectUrls: string;
  displayName: any;
  clientId: any;
  companyId: any;
  clientSecret: ReactNode;
  isSyncronized: any;
  id: number;
  name: string;
  description?: string;
  redirectUrl: string;
  status: 'active' | 'inactive';
  users: number;
  lastActivity: string;
  type: string;
}

// Interface ApplicationFormData: Définit la structure des données pour la création ou la mise à jour d'une application.
export interface ApplicationFormData {
  name: string;
  redirectUri: string;
  description?: string;
  displayName?: "",
  clientId?: string,
  clientSecret?: null,
  postLogoutRedirectUris:string,
}

// Interface AnalyticsData: Définit la structure des données analytiques.
export interface AnalyticsData {
  type: string;
  value: number;
}

// Interface ApplicationUser: Définit la structure des données d'un utilisateur d'application.
export interface ApplicationUser {
  id: number;
  username: string;
  email: string;
  role: string;
  lastLogin?: string;
}
const apiClient = axios.create({
  // baseURL: API_BASE_URL,
  withCredentials:true

});


apiClient.interceptors.response.use(response =>   
  {
    console.log('headerrr new',response?.headers)
    return response
  },   
  async error => {
    console.log("interceptors call here")
    const originalRequest = error.config;    
    const is401 = error.response?.status === 401;    
    const reauth = error.response?.headers['x-reauth'] === 'true';
    console.log("reauth value", reauth)
    console.log("already retrying", !originalRequest._retry)
    console.log("Is401 response value", is401)

    
    if (is401 && reauth && !originalRequest._retry) 
      {
        originalRequest._retry = true;
        console.log("retry de la requete in process")
        try {       
           return await apiClient(originalRequest);      
          } catch (err) {
               return Promise.reject(err);      
              }    
            }    
        return Promise.reject(error);
        });

        


export const fetchAdminInfo = async (): Promise<AdminInfo> => {
  try {
  
    const response = await apiClient.get(
      `${API_BASE_URL}/Company/admin/me`,
    );
    console.log("user admin info : ", response.data)
    // return rsp.json()
    const companyId = response.data.data.companyId;
    localStorage.setItem('company', companyId.toString());
    return  response.data.data;
   
    
  } catch (error) {
    handleError(error);
    throw error;
  }
};



// getCompanyApplications: Récupère la liste des applications d'une entreprise en utilisant useSWR.
export const getCompanyApplications = (): Application[] => {
  const { data, error } = useSWR(`${API_BASE_URL}/Company/{companyId}/applications`, fetcher);

  if (error) {
    console.error('Erreur lors de la récupération des applications:', error);
    return [];
  }

  if (!data) {
    return [];
  }

  return data;
};

// deleteApp: Supprime une application en utilisant l'ID de l'entreprise et l'ID de l'application.
export const deleteApp = async (companyId: string, appId: string): Promise<void> => {

  try {
    await apiClient.delete(`${API_BASE_URL}/Company/${companyId}/applications/${appId}`,
      // {
      //   withCredentials:true,
      // }
      );

    // Invalide le cache SWR pour actualiser les données.
    mutate(`${API_BASE_URL}/Company/${companyId}/applications`);
  } catch (error) {
    handleError(error);
    throw error;
  }
};

// fetchAnalytics: Récupère les données analytiques des applications.
export const fetchAnalytics = (): AnalyticsData[] => {
  const { data, error } = useSWR(`${API_BASE_URL}/applications/analytics`, fetcher);

  if (error) {
    console.error('Erreur lors de la récupération des données analytiques:', error);
    return [];
  }

  if (!data) {
    return [];
  }

  return data;
};

// updateApplicationStatus: Met à jour le statut d'une application (active/inactive).
export const updateApplicationStatus = async (
  id: number,
  status: 'active' | 'inactive'
): Promise<Application> => {
  try {
    const response = await axios.patch(`${API_BASE_URL}/applications/${id}/status`, { status });

    // Invalide le cache SWR pour déclencher une revalidation.
    mutate(`${API_BASE_URL}/applications/${id}/status`);

    return response.data;
  } catch (error) {
    handleError(error);
    throw error;
  }
};

// fetchApplicationUsers: Récupère la liste des utilisateurs d'une application spécifique.
export const fetchApplicationUsers = (companyId: number, applicationId: number): ApplicationUser[] => {
  const { data, error } = useSWR(`${API_BASE_URL}/Companies/${companyId}/applications/${applicationId}/users`, fetcher);

  if (error) {
    console.error('Erreur lors de la récupération des utilisateurs d\'application:', error);
    return [];
  }

  if (!data) {
    return [];
  }

  return data;
};

// addUserToApplication: Ajoute un utilisateur à une application.
export const addUserToApplication = async (userData: Partial<ApplicationUser>): Promise<ApplicationUser> => {
  try {
    const response = await  apiClient.post(`${API_BASE_URL}Company/{companyId}/applications/{applicationId}/users`, userData);

    // Invalide le cache SWR pour déclencher une revalidation.
    mutate(`${API_BASE_URL}Company/{companyId}/applications/{applicationId}/users`);

    return response.data;
  } catch (error) {
    handleError(error);
    throw error;
  }
};

// handleError: Gère les erreurs des appels API en les loguant.
const handleError = (error: unknown) => {
  if (axios.isAxiosError(error)) {
    console.error('Erreur d\'API:', error.response?.data || error.message);
  } else {
    console.error('Erreur inattendue:', error);
  }
};

// updateApplication: Met à jour les informations d'une application.
export const updateApplication = async (
  companyId: string,
  appId: string,
  data: Partial<ApplicationFormData>
): Promise<Application> => {
  try {
    // Préparation des données à envoyer à l'API.
    const updateData = {
      displayName: data.displayName,
      redirectUris: data.redirectUri,
      postLogoutRedirectUris:data.postLogoutRedirectUris

    };

    const response = await  apiClient.put(
      `${API_BASE_URL}/Company/${companyId}/applications/${appId}`,
      updateData,
     
    );

    // Invalide le cache SWR pour actualiser les données.
    mutate(`${API_BASE_URL}/Company/${companyId}/applications/${appId}`);
    mutate(`${API_BASE_URL}/Company/${companyId}/applications`);

    return response.data;
  } catch (error) {
    handleError(error);
    throw error;
  }
};

export const createApplication = async (formData: FormData): Promise<Application> => {
  try {
    const companyId = localStorage.getItem("company");
    // S'assurer que l'URL est correcte avec companyId dans le chemin
    const response = await  apiClient.post(
      `${API_BASE_URL}/Company/${companyId}/applications`,
      formData,
      {
        // headers: {
        //   Authorization: `Bearer ${token}`,
        //    'Content-Type': 'application/x-www-form-urlencoded'
        // }
      }
    );

    mutate(`${API_BASE_URL}/Company/${companyId}/applications`);
    return response.data;
  } catch (error) {
    handleError(error);
    throw error;
  }
};

// Interface AdminInfo: Définit la structure des informations de l'administrateur.
export interface AdminInfo {
  companyName: string;
  companyId: string;
  email: string;
  fullName: string;
  subscriptionStartDate : String
  subscriptionEndDate :String
  // subscriptionStartDate : Date
  // subscriptionEndDate : Date
  adminData : any
};


